import { render, staticRenderFns } from "./TopFlapping.vue?vue&type=template&id=168e8f71&"
import script from "./TopFlapping.vue?vue&type=script&lang=js&"
export * from "./TopFlapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports